export const GET_KPIS = "GET_KPIS";
export const CREATE_KPI = "CREATE_KPI";
export const DELETE_KPI = "DELETE_KPI";
export const GET_GENERATED_KPIS = "GET_GENERATED_KPIS";
export const UPDATE_KPIS = "UPDATE_KPIS";
